import clsx from 'clsx';

import styles from './CircleSpinner.module.scss';

export const CircleSpinner = ({ className }: { className?: string }) => {
    return <span className={clsx(styles.spinner, className)} />;
};
